module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-sleepy.6f1c8400.png";